import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { GeneralService } from '@ex/module/core/services/general.service';
import { ModuleName } from '../../enums/ModuleName';
import { Chart } from '@ex/module/core/modules/chart/builder';
import { CustomChartExport } from '../chart-export-helpers.service';

@Component({
  selector: 'export-e-chart-vertical',
  templateUrl: './export-e-chart-vertical.component.html',
  styleUrls: ['./export-e-chart-vertical.component.scss']
})
export class ExportEChartVerticalComponent implements OnInit {
  ModuleNames = ModuleName;
  @Input() categoryTemplate: TemplateRef<any>;
  @Input() categoriesTemplate: TemplateRef<any>;
  @Input() breakIndex: number = 30;
  @Input() exportChart: CustomChartExport;

  @Input() language;
  @Input() rows: number = 1;
  constructor(public generalService: GeneralService) { }
  ngOnInit(): void {
  }


  breakCondition(index) {
    let indexCalc = this.breakIndex * (this.rows / 2);
    return (index % indexCalc == 0 && index >= indexCalc) ? true : false;
  }
  fullWidthChartCheck(categories) {
    if (categories.find(x => x.length > 15))
      return true;
    else return false;
  }
  logData(x) {
    console.log(x);

  }
}
